<div class="bottom-bar">
  <div class="bottom-bar__main" [ngClass]="{ 'bottom-bar__main--sticky': sticky }">
    <ng-content></ng-content>
  </div>
</div>
